import {
	Checkbox,
	Col,
	Form,
	Input,
	Row,
	Typography,
	notification,
} from "antd";
import React, { useEffect, useState } from "react";
import { api } from "../utils/Api";
import axios from "axios";
import { CustomSpinner } from "../utils/CustomComponents";
const { Text } = Typography;

const ProductionDailyView = ({ productionId }) => {
	const [form] = Form.useForm();
	const [loadingButton, setLoadingButton] = useState(true);
	const [initialValues, setInitialValues] = useState({});
	const [apiNotification, contextHolder] = notification.useNotification();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	useEffect(() => {
		getProduction();
	}, []);

	const getProduction = async () => {
		try {
			setLoadingButton(true);

			const url = api + `/production-new/eticket/${productionId}`;
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.get(url);
			if (data.success) {
				const payload = data.payload;
				setInitialValues({
					emergencyStopOK: payload.emergencyStop,
					emergencyStopNOK: !payload.emergencyStop,
					emergencyStopComment: payload.emergencyStopComment,
					waterDispensingOK: payload.waterDispensing,
					waterDispensingNOK: !payload.waterDispensing,
					waterDispensingComment: payload.waterDispensingComment,
					admixtureDispensingOK: payload.admixtureDispensing,
					admixtureDispensingNOK: !payload.admixtureDispensing,
					admixtureDispensingComment: payload.admixtureDispensingComment,
					aggregateGatesOK: payload.aggregateGates,
					aggregateGatesNOK: !payload.aggregateGates,
					aggregateGatesComment: payload.aggregateGatesComment,
					conveyorRotationOK: payload.conveyorRotation,
					conveyorRotationNOK: !payload.conveyorRotation,
					conveyorRotationComment: payload.conveyorRotationComment,
				});
				setLoadingButton(false);
			} else {
				setLoadingButton(false);
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			setLoadingButton(false);
			openNotification(
				"error",
				"Error",
				"Error while trying to get production",
			);
			console.error(err.message);
			return null;
		}
	};

	const CustomForm = () => {
		return (
			<Form
				form={form}
				layout="vertical"
				style={{ marginTop: "20px" }}
				initialValues={initialValues}
			>
				<Row gutter={16} style={{ paddingBottom: 20, paddingTop: 20 }}>
					<Col span={24}>
						<Row gutter={16} justify={"space-between"}>
							<Col span={8}>
								<Text strong>Description / Additional Description</Text>
							</Col>
							<Col span={8}>
								<Text strong>Comments</Text>
							</Col>
							<Col>
								<Row gutter={16} justify={"end"}>
									<Col>
										<Text strong>OK</Text>
									</Col>
									<Col>
										<Text strong>NOK</Text>
									</Col>
								</Row>
							</Col>
						</Row>
					</Col>
				</Row>
				<Row gutter={16}>
					<ItemChecked
						ok={"emergencyStopOK"}
						nok={"emergencyStopNOK"}
						text={"emergencyStopComment"}
						title={"Emergency Stop"}
						description={""}
						type={"comment"}
					/>
					<ItemChecked
						ok={"waterDispensingOK"}
						nok={"waterDispensingNOK"}
						text={"waterDispensingComment"}
						title={"Water Dispensing"}
						description={""}
						type={"comment"}
					/>
					<ItemChecked
						ok={"admixtureDispensingOK"}
						nok={"admixtureDispensingNOK"}
						text={"admixtureDispensingComment"}
						title={"Admixture Dispensing"}
						description={""}
						type={"comment"}
					/>
					<ItemChecked
						ok={"aggregateGatesOK"}
						nok={"aggregateGatesNOK"}
						text={"aggregateGatesComment"}
						title={"Aggregate Gates"}
						description={""}
						type={"comment"}
					/>
					<ItemChecked
						ok={"conveyorRotationOK"}
						nok={"conveyorRotationNOK"}
						text={"conveyorRotationComment"}
						title={"Conveyor Rotation"}
						description={""}
						type={"comment"}
					/>
				</Row>
			</Form>
		);
	};

	return (
		<>
			{contextHolder}
			{loadingButton ? <CustomSpinner /> : <CustomForm />}
		</>
	);
};

export default ProductionDailyView;

const ItemChecked = ({ ok, nok, text, title, description, type }) => {
	return (
		<Col span={24}>
			<Row gutter={16} justify={"space-between"}>
				<Col span={8}>
					<Row>
						<Col span={24}>
							<Text strong>{title}</Text>
						</Col>
						<Col span={24} seco>
							<Text strong type="secondary">
								{description}
							</Text>
						</Col>
					</Row>
				</Col>
				<Col span={8}>
					<Form.Item name={text}>
						{type === "comment" && <Input.TextArea size="large" readOnly />}
					</Form.Item>
				</Col>
				<Col>
					<Row gutter={16}>
						<Col>
							<Form.Item name={ok} valuePropName="checked">
								<Checkbox style={{ pointerEvents: "none" }}></Checkbox>
							</Form.Item>
						</Col>
						<Col>
							<Form.Item name={nok} valuePropName="checked">
								<Checkbox style={{ pointerEvents: "none" }}></Checkbox>
							</Form.Item>
						</Col>
					</Row>
				</Col>
			</Row>
		</Col>
	);
};
